import { render, staticRenderFns } from "./Twitter.vue?vue&type=template&id=cdffaabe&"
import script from "./Twitter.vue?vue&type=script&lang=js&"
export * from "./Twitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports